import React, { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { rewardSummary } from '../../util/api';
import css from './StudentRewardsSummary.module.css';

const StudentRewardsSummary = ({ studentUserId, className }) => {
  const intl = useIntl();
  const [rewards, setRewards] = useState(null);

  useEffect(() => {
    let isMounted = true;
    if (studentUserId) {
      rewardSummary({ userId: studentUserId })
        .then(res => {
          if (isMounted) {
            const data = (res && res.data) || res || {};
            setRewards(data);
          }
        })
        .catch(() => {});
    }
    return () => {
      isMounted = false;
    };
  }, [studentUserId]);

  if (!rewards) return null;

  const stars = rewards.totalStars ?? 0;
  const streak = rewards.activeStreakWeeks !== undefined && rewards.activeStreakWeeks !== null
    ? rewards.activeStreakWeeks
    : (rewards.activeStreakDays ? Math.max(1, Math.floor(rewards.activeStreakDays / 7) || 1) : 0);

  const starsText = intl
    ? intl.formatMessage({ id: 'InboxPage.rewardsStars', defaultMessage: '{count} Stars' }, { count: stars })
    : `${stars} Stars`;

  const streakText = intl
    ? intl.formatMessage({ id: 'InboxPage.rewardsStreak', defaultMessage: '{count} Week Streak' }, { count: streak })
    : `${streak} Week Streak`;

  return (
    <div className={`${css.studentRewardsContainer} ${className || ''}`}>
      <span className={css.rewardPillStars} title="Student Stars Balance">
        <svg className={css.rewardStarIcon} viewBox="0 0 24 24" width="14" height="14" fill="#FFB800">
          <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
        </svg>
        <span className={css.rewardValue}>{starsText}</span>
      </span>
      <span className={css.rewardPillStreak} title="Current Learning Streak">
        <svg className={css.rewardFlameIcon} viewBox="0 0 24 24" width="14" height="14" fill="#FF5722">
          <path d="M13.5 0.67c-0.54 0.38-1.57 1.76-1.57 3.33 0 1.94 1.5 3.5 3.5 3.5 0.35 0 0.69-0.06 1-0.16 0.17 1.52-0.5 3.03-1.78 3.96C13.57 12.08 12 13.9 12 16c0 0.81 0.24 1.57 0.66 2.21-0.22 0.02-0.44 0.04-0.66 0.04-4.42 0-8-3.58-8-8 0-3.3 2.01-6.13 4.88-7.34C8.6 3.42 8 4.63 8 6c0 2.21 1.79 4 4 4 0.34 0 0.67-0.05 1-0.13-0.61-0.87-1-1.92-1-3.07 0-2.31 1.4-4.3 3.5-5.13zM12 22c5.52 0 10-4.48 10-10 0-2.35-0.81-4.51-2.17-6.22C19.92 7.04 20 8.01 20 9c0 4.42-3.58 8-8 8-0.99 0-1.96-0.18-2.87-0.51C10.08 19.34 10.96 22 12 22z"/>
        </svg>
        <span className={css.rewardValue}>{streakText}</span>
      </span>
    </div>
  );
};

export default StudentRewardsSummary;
